<template>
  <v-container>
    <v-row>
      <v-col
        class="text-center mt-4 pa-0"
      >
        <h1>
          Account Information
        </h1>
      </v-col>
    </v-row>


        <v-row
      justify="center"
    >
      <v-col
        xs="12"
        sm="12"
        md="10"
        lg="8"
        xl="6"
      >
        <v-expansion-panels
          hover
          popout
          focusable
        >
        <!--------------------------------------->
        <!--          Change Password          -->
        <!--------------------------------------->
          <v-expansion-panel>
            <v-expansion-panel-header>
                <v-row
                  justify="center"
                  class="headline"
                >
                  Login Info
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <ChangePassword
                class="pa-0"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>

        <!--------------------------------------->
        <!--               People              -->
        <!--------------------------------------->
          <v-expansion-panel>
            <v-expansion-panel-header>
                <v-row
                  justify="center"
                  class="headline"
                >
                  People
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <People
                class="pa-0"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>

        <!--------------------------------------->
        <!--              Address              -->
        <!--------------------------------------->
          <v-expansion-panel>
            <v-expansion-panel-header>
                <v-row
                  justify="center"
                  class="headline"
                >
                  Address
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <Address
                class="pa-0"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>

        <!--------------------------------------->
        <!--              Billing              -->
        <!--------------------------------------->
          <v-expansion-panel>
            <v-expansion-panel-header>
                <v-row
                  justify="center"
                  class="headline"
                >
                  Payment Settings
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <Billing
                class="pa-0"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import People from '@/components/people/People.vue'
import ChangePassword from '@/components/login/ChangePassword.vue'
import Address from '@/components/account_information/ShippingAddress.vue'
import Billing from '@/components/account_information/Billing.vue'

export default {
  name: 'account',
  components: {
    People,
    Address,
    Billing,
    ChangePassword
  },

  computed: {
    user() {
      return this.$store.getters['data/user'];
    },

    accountInfo() {
      return this.$store.getters['data/account'];
    },

  },

  methods: {

  },

}
</script>
